import { render, staticRenderFns } from "./OVGCreateView.vue?vue&type=template&id=7c318b2b&scoped=true&lang=pug"
import script from "./OVGCreateView.vue?vue&type=script&lang=js"
export * from "./OVGCreateView.vue?vue&type=script&lang=js"
import style0 from "./OVGCreateView.vue?vue&type=style&index=0&id=7c318b2b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c318b2b",
  null
  
)

export default component.exports